// extracted by mini-css-extract-plugin
export default {"relateShortRecom":"index_relateShortRecom_NAfnT","shortAppTxt":"index_shortAppTxt_zJd6I","boxBottomLine":"index_boxBottomLine_m2HsZ"};